"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinAvailableOrCreate = joinAvailableOrCreate;
async function underlyingFunction(baseUrl, request) {
    return await fetch(`${baseUrl}/Play/Matchmaking/Lobbies/JoinAvailableOrCreateV2`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": request.authToken
        },
        body: JSON.stringify({
            ...request,
            authToken: undefined
        })
    })
        .then(x => x.json())
        .then(x => x)
        .catch(() => ({ error: { code: "networkError", message: "A network error happened" } }));
}
async function joinAvailableOrCreate(request) {
    while (true) {
        const response = await underlyingFunction(this.baseUrl, request);
        if (response.error) {
            switch (response.error.code) {
                case "matchmakingTimeout":
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                    continue;
                case "invalidToken":
                case "invalidAcceptedLocations":
                case "gameNotFound":
                case "gatewayError":
                case "networkError":
                default:
                    return response;
            }
        }
        var attempts = 0;
        while (attempts++ < 60) {
            const lobby = await this.getCurrent(request.authToken);
            if (lobby.error) {
                switch (lobby.error.code) {
                    case "notInALobby":
                        await new Promise((resolve) => setTimeout(resolve, 1000));
                        continue;
                    default:
                        return lobby;
                }
            }
            if (lobby.node == null) {
                await new Promise((resolve) => setTimeout(resolve, 1000));
                continue;
            }
            return {
                error: undefined,
                id: lobby.id,
                url: lobby.node.url,
                sessionToken: lobby.sessionToken
            };
        }
        return {
            error: {
                code: "matchmakingTimeout",
                message: "Could not find a match in time"
            }
        };
    }
}
//# sourceMappingURL=joinAvailableOrCreate.js.map